import type { SpellChecker } from '../types/spell-checker'

let checkerPromise: Promise<SpellChecker> | null = null

/**
 * Loads the en_US wordlist (about 550 KB) the first time it is asked for, so none of it is in the
 * main bundle. One shared promise: later callers reuse the same checker, and a failed load clears
 * it so the next open of the panel retries. `@dictionary-en` is a Vite alias for the
 * `dictionary-en` package folder, whose `exports` map doesn't expose the raw .aff/.dic files.
 */
export function loadSpellChecker(): Promise<SpellChecker> {
  checkerPromise ??= (async () => {
    const [{ default: nspell }, aff, dic] = await Promise.all([
      import('nspell'),
      import('@dictionary-en/index.aff?raw'),
      import('@dictionary-en/index.dic?raw'),
    ])
    const speller = nspell(aff.default, dic.default)

    return {
      isCorrect: (word) => speller.correct(word),
      suggest: (word, limit) => speller.suggest(word).slice(0, limit),
    } satisfies SpellChecker
  })().catch((error: unknown) => {
    checkerPromise = null
    throw error
  })

  return checkerPromise
}
